var _g, _polygon, _path, _path2, _path3, _polygon2, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _circle, _ellipse2, _circle2, _path16, _path17, _polygon3, _polygon4, _polygon5, _rect, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect2, _path47, _path48, _path49, _g4, _path50, _path51, _path52, _path53, _ellipse4, _ellipse5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect3, _path54, _path55, _path56, _path57, _circle3, _ellipse6, _circle4, _path58, _path59, _ellipse7, _path60, _path61, _path62, _ellipse8, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNurse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab8fc4ca-c8d8-495c-8f75-143fc6a1c15f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb3a5b01-1684-4d93-b7a1-22f0864d29d6",
    "data-name": "freesvgillustration--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.34,
    y: 595.1,
    width: 857.09,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718.77,
    y: 622.69,
    width: 56.77,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.21,
    y: 627.35,
    width: 14.9,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.16,
    y: 606.78,
    width: 32.9,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.26,
    y: 609.66,
    width: 74.04,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.57,
    y: 609.66,
    width: 10.85,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 616.89,
    width: 160.58,
    height: 0.43,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.6,518.65h-331a9.8,9.8,0,0,1-9.78-9.79V43.58a9.8,9.8,0,0,1,9.78-9.7h331a9.79,9.79,0,0,1,9.79,9.79h0V508.86A9.79,9.79,0,0,1,410.6,518.65ZM79.61,34.22a9.36,9.36,0,0,0-9.35,9.36V508.86a9.36,9.36,0,0,0,9.35,9.36h331a9.38,9.38,0,0,0,9.36-9.36V43.58a9.38,9.38,0,0,0-9.36-9.36Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.39,518.65h-331a9.8,9.8,0,0,1-9.78-9.79V43.58a9.8,9.8,0,0,1,9.78-9.7h331a9.79,9.79,0,0,1,9.76,9.7V508.86A9.79,9.79,0,0,1,781.39,518.65Zm-331-484.43A9.38,9.38,0,0,0,441,43.58V508.86a9.38,9.38,0,0,0,9.36,9.36h331a9.37,9.37,0,0,0,9.36-9.36V43.58a9.38,9.38,0,0,0-9.36-9.36Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.57,
    y: 136.41,
    width: 193.53,
    height: 456.73,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.93,
    y: 163.9,
    width: 39.79,
    height: 191.73,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.33,392.15a9.7,9.7,0,1,1-9.75-9.66h0A9.7,9.7,0,0,1,168.33,392.15Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.02,
    y: 95.47,
    width: 80.6,
    height: 27.41,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.28 492.41 440 492.41 440 383.78 735.61 383.78 735.61 490.21 725.32 490.21 725.32 394.06 450.28 394.06 450.28 492.41",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.14,
    y: 439.41,
    width: 285.34,
    height: 10.29,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.14,
    y: 388.92,
    width: 285.34,
    height: 55.63,
    rx: 7.42,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.12,475.09H721.88a8.58,8.58,0,0,1,8.57,8.58v8.14H388.54v-8.14a8.57,8.57,0,0,1,8.57-8.58Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.68 595.31 383.39 595.31 383.39 486.7 679 486.7 679 593.13 668.72 593.13 668.72 496.99 393.68 496.99 393.68 595.31",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.28 595.31 440 595.31 440 486.7 735.61 486.7 735.61 593.13 725.32 593.13 725.32 496.99 450.28 496.99 450.28 595.31",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.62,
    y: 142.06,
    width: 120.49,
    height: 153.09,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.36,
    y: 144.81,
    width: 115,
    height: 147.59,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629,214c4.48,4.93,5.58-4.85,5.58-4.85l12.75-21.65,2.78,22.28-9.59,68.88s-8.77,2.6-9.34,4.08,15,1.86,16.72,0-1.72-4.08-1.72-4.08l12-57,.19.91,11.86,56s-3.32,2.21-1.71,4.08,17.26,1.47,16.71,0-9.34-4.08-9.34-4.08l-9.57-68.88,2.75-22.28,12.75,21.65s1.11,9.78,5.57,4.85-3.34-9.36-3.34-9.36l-13.87-24L662.51,178l-1.71-2.13s9.81-17.6-2.54-17.94h-.37c-12.35.34-2.56,17.94-2.56,17.94L653.62,178,646,180.65l-13.85,24S624.55,209.1,629,214Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.45,157.88v64.7l11.86,56s-3.32,2.22-1.71,4.08,17.26,1.48,16.71,0-9.34-4.08-9.34-4.08l-9.56-68.87,2.74-22.29L681.9,209.1s1.12,9.79,5.57,4.86-3.34-9.36-3.34-9.36l-13.87-24L662.62,178l-1.72-2.13S670.79,158.23,658.45,157.88Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.09,
    y: 162,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.69,
    y: 189.89,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.3,
    y: 219.2,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680.94,
    y: 161.78,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.09,
    y: 229.49,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.93,
    y: 253.21,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.13,
    y: 259.43,
    width: 15.92,
    height: 6.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.39,
    y: 141.34,
    width: 116.38,
    height: 154.53,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.15,
    y: 144.09,
    width: 110.87,
    height: 149.05,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.15,
    y: 144.09,
    width: 110.87,
    height: 37.04,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.15,
    y: 215.41,
    width: 110.87,
    height: 40.73,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.55,161a11.23,11.23,0,1,0,11.23-11.23h0a11.21,11.21,0,0,0-11.23,11.2Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.95,
    cy: 198.03,
    r: 11.23,
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.22,237.61a11.23,11.23,0,1,0,11.22-11.23h0A11.24,11.24,0,0,0,473.22,237.61Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.61,
    cy: 274.67,
    r: 11.23,
    fill: "#fafafa"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "324.49 621.57 345.76 619.28 357.54 627.19 349.98 635.45 325.02 635.1 319.22 623.32 324.49 621.57",
    fill: "#f9b499"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.24,620.69s-5.45,20.39,12,20.91c0,0,42.36,3.34,57.65-1.23l-25.31-13.18s-28.65,3.52-33.05-5.62Z",
    fill: "#243E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.64,589.79l3.74,8.15c-23.09-2.37-38.71-30.55-38.71-30.55l7.13-15.63,7.13-1,27.17,29.88Z",
    fill: "#f9b499"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258.26,628.06c-15.18-5.12-50.27-41-50.27-41-6.07-8.92,4.68-19.7,4.68-19.7s15.62,28.18,38.71,30.55l5.93,17C260.92,628.44,258.26,628.06,258.26,628.06Z",
    fill: "#243E59"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.8 551.76 217.08 557.19 247.65 589.79 254.1 580.62 226.93 550.74 219.8 551.76",
    fill: "#f7a48b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338,339.53s5.43,21.39,9.85,64.86A199.93,199.93,0,0,1,341,451.93L256.13,585,211,548.7l71-110.7,32.26-93.38Z",
    fill: "#EC1C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338,339.53s5.43,21.39,9.85,64.86A199.93,199.93,0,0,1,341,451.93L256.13,585,211,548.7l71-110.7,32.26-93.38Z",
    fill: "#fff",
    opacity: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.51,
    y: 514.16,
    width: 113.81,
    height: 1.06,
    transform: "translate(-313.07 452.7) rotate(-56.99)",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.22,323.29s-18.09,23.33-12,51.59c0,0,10,41.34,23.1,75.38,0,0,17,46.2,17,81.15l9.72,93.31,67.48-4.86s-6.83-121.81-25.4-169.7a117,117,0,0,1-5.69-19.94c-4.26-21.75-12.63-65.28-14.59-81.44L310.26,337.5l-39.21-17Z",
    fill: "#EC1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.22,323.29s-18.09,23.33-12,51.59c0,0,10,41.34,23.1,75.38,0,0,17,46.2,17,81.15l9.72,93.31,67.48-4.86s-6.83-121.81-25.4-169.7a117,117,0,0,1-5.69-19.94c-4.26-21.75-12.63-65.28-14.59-81.44L310.26,337.5l-39.21-17Z",
    fill: "#fff",
    opacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.88,620.77c-.6-49.83-18.65-160.5-18.83-161.61-6-34.8-30.13-100.75-30.37-101.42l1-.36c.24.66,24.4,66.7,30.42,101.6.18,1.12,18.25,111.87,18.85,161.78Z",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M405.09,349.88c-1.86,5.17-2.89,17.58-2.89,17.58H385c-9.31-10.34-22.55-30.2-22.55-30.2l15.24-4.08,10.2-2.75,2.28,2.9Z",
    fill: "#f9b499"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402.2,366v1.45H385c-9.31-10.34-22.55-30.2-22.55-30.2l15.24-4.08a21.87,21.87,0,0,0,7.1,18.36Z",
    fill: "#f7a48b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M364.36,179.15l-4.26,5-12.46,14.49s-7,19.15-5.17,32.52l-2.42,5.77s-25.48-2.78-42.56,11.56h0c-.44-.74-13.05-22.43,23.41-35.87,0,0,9.11-.92,2.42-11.56,0,0-8.42-12,2.57-23.42A26.67,26.67,0,0,1,340.43,170C348.15,168.6,360,168.45,364.36,179.15Z",
    fill: "#243E59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.64,198.61s-7,19.15-5.17,32.52l-2.42,5.77s-27.38-2.65-42.56,11.56h0c-.16-.68-4.13-19,18.55-25.84,0,0,25.83-4.26,17-20.67,0,0-13.68-18.23,4.86-24,0,0,18.4-4.42,22.18,6.18Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M349.24,374.51h69.52a0,0,0,0,1,0,0v11.17a0,0,0,0,1,0,0H353a3.75,3.75,0,0,1-3.75-3.75v-7.42A0,0,0,0,1,349.24,374.51Z",
    fill: "#bcbec0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M339,367.44h79.94a0,0,0,0,1,0,0v11.17a0,0,0,0,1,0,0H339a5.25,5.25,0,0,1-5.25-5.25v-.67A5.25,5.25,0,0,1,339,367.44Z",
    fill: "#d1d3d4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M481.37,424.43c-59.25,0-107.28,47.69-107.28,106.52s48,106.53,107.28,106.53S588.66,589.79,588.66,531,540.63,424.43,481.37,424.43ZM482.29,622a91.79,91.79,0,1,1,91.78-91.78A91.78,91.78,0,0,1,482.29,622Z",
    fill: "#a7a9ac"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M482.29,438.41c-51.2,0-92.7,41.26-92.7,92.16s41.5,92.17,92.7,92.17S575,581.48,575,530.57,533.49,438.41,482.29,438.41Zm-1,178.23a86.3,86.3,0,1,1,86.34-86.29A86.31,86.31,0,0,1,481.29,616.64Z",
    fill: "#bcbec0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.37,
    cy: 530.3,
    rx: 86.41,
    ry: 86.21,
    fill: "#fff",
    opacity: 0.33
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 621.01,
    cy: 600.96,
    r: 26.97,
    fill: "#939598"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 618.07,
    cy: 600.96,
    rx: 19.12,
    ry: 20.1,
    fill: "#231f20",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.33,
    cy: 600.72,
    r: 12.01,
    fill: "#231f20",
    opacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M642.51,521l.3,69.7-9.16-.23V524.57a2.21,2.21,0,0,0-2.22-2.21h-16.6l2.89-5.62,1.53-3h16.06A7.2,7.2,0,0,1,642.51,521Z",
    fill: "#d1d3d4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M637.41,520.52v69.92h-3.76V524.57a2.21,2.21,0,0,0-2.22-2.21h-16.6l2.89-5.62h15.91A3.78,3.78,0,0,1,637.41,520.52Z",
    fill: "#bcbec0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "643.89 590.69 566.3 602.52 570.48 617.82 645.28 602.52 643.89 590.69",
    fill: "#bcbec0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "615.01 589.64 643.89 590.69 566.3 602.52 563.87 597.64 615.01 589.64",
    fill: "#d1d3d4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "606.31 577.47 601.79 571.2 587.18 569.81 553.43 587.21 553.43 590.34 563.87 597.64 589.27 592.77 606.31 577.47",
    fill: "#f9b499"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 519.51,
    y: 417.09,
    width: 83.35,
    height: 48.54,
    fill: "#EC1C24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M623.07,589.64H623L558.3,600.08,547.51,598l-1.73-5.92,7.65-1.73s20.88,7,22.61.69c0,0,.44-9,6.36-10.35a9.9,9.9,0,0,1,6.17,1,11,11,0,0,0,4.16.78,5.73,5.73,0,0,0,5.58-3.91s3.48-7,8-1c0,0,7.65,5.56,17,5.91l0,0c.48.17,4.11,1.57,4.59,3.14,0,.05,0,.11,0,.17C628.2,587.7,627,588.75,623.07,589.64Z",
    fill: "#EC1C24"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M613.28,535.72c-8,16.7-11.49,35.48-11.49,35.48-3.32-.43-9.91,2.51-14.24,4.71-2.46,1.25-4.2,2.25-4.2,2.25l-55,24.7c-9.4-10.79-10.1-63.67-10.1-63.67l-90.11-63.31v-17.4l70.28-25.05,34.78-2.61a205.77,205.77,0,0,1,67.5,10.26C652.24,459.87,613.28,535.72,613.28,535.72Z",
    fill: "#243E59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M587.55,575.91c-2.46,1.25-4.2,2.25-4.2,2.25l-55,24.7c-9.4-10.79-10.1-63.67-10.1-63.67l4.87-5.56,2.44,9.75,3.13,32c2.09,15.66,54.62-2.08,54.62-2.08-2-67.93-9.89-96.12-13.92-106.31a13.33,13.33,0,0,0-7.1-7.3c-14.34-6.24-48.1-16.86-50.2-17.52l34.34,8.32c37.23,6.95,41.06,26.44,41.06,26.44C596.67,494.87,588,571.8,587.55,575.91Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M623.07,589.64H623l-18.1,2.42c-.35-3.82-6.26-2.77-6.26-2.77-7.83-1.31-15.35-7.81-16.26-8.62a9.9,9.9,0,0,1,6.17,1,11,11,0,0,0,4.16.78v.26a72.37,72.37,0,0,0,12.88,5.22c10.78,4.17,17.74-4.52,17.74-4.52l0,0c3,1.26,4.27,2.3,4.59,3.14,0,.05,0,.11,0,.17a1.34,1.34,0,0,1,0,.2C628.13,588.72,623.64,589.54,623.07,589.64Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M621.5,415.39v5.13H512.15V407.78H613.88A7.61,7.61,0,0,1,621.5,415.39Z",
    fill: "#d1d3d4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M621.5,415.39v5.13H512.69l-.54-2.77,4.14-1.28h96.82c6.4,0,.53-8.69.53-8.69A7.73,7.73,0,0,1,621.5,415.39Z",
    fill: "#bcbec0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M513.74,418.57l-3.42,12.77h0c.1.4,2.1,8.22-4.34,8.88-6.61.68-12.3,1.36-12.3,1.36-21.89,4.34-57.22,16.65-57.22,16.65-7.3,5-10.49,1.6-10.49,1.6a26.5,26.5,0,0,1-6.91-7.67c-7.95-12.27-13.6-32.46-13.6-32.46-11-28.94-.24-70.89-.24-70.89,4.57-22.34,40.36-26.75,40.36-26.75l14.59,14.44L477,332,489.58,326c30.54,7.29,35.56,53.11,35.56,53.11l33.28-.91,5.48,22.11C541.78,416.3,513.74,418.57,513.74,418.57Z",
    fill: "#EC1C24"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M506,440.23c-6.61.68-12.3,1.36-12.3,1.36-21.89,4.34-57.22,16.65-57.22,16.65-7.3,5-10.49,1.6-10.49,1.6a26.5,26.5,0,0,1-6.91-7.67l34.34-8s27.35-10,31.61-11.54l25.3-1.3h0C510.43,431.75,512.43,439.57,506,440.23Z",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M456.76,308l-.23,10.26s-4.94.07-4.33,3.42c0,0,2.28,10.94,17.78,9.72,0,0,14.13,0,10.94-11.7l-.15-7s-6.39,2.13-11.25-2.28Z",
    fill: "#f9b499"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M456.76,308l-.23,10.26s12.23-.53,16-6a8.66,8.66,0,0,1-3-1.82Z",
    fill: "#f7a48b"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 464.69,
    cy: 285.15,
    rx: 26.93,
    ry: 21.06,
    transform: "translate(94.19 685.11) rotate(-78.72)",
    fill: "#f9b499"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M498.55,318.5c-6.72,8.09-16.26,1.76-16.26,1.76,2.43-.61,3.79-3.73,3.79-3.73l-5.62.76.3-4.56a12.06,12.06,0,0,1-5.57.34,12.28,12.28,0,0,1-5.22-2.25c-.14-.1-.29-.23-.45-.37,14.28-5.92,12-24.32,12-24.32-6.69.77-8.36-7.74-8.36-7.74a12.84,12.84,0,0,0-.46,6.07C462.53,283.4,461,272.3,461,272.3a5.57,5.57,0,0,0-1.52,4,20.64,20.64,0,0,0-9-9.27,33.82,33.82,0,0,0-4.73,8.07l-.13.32a32,32,0,0,0-2.29,11.5c0,.86,0,1.7,0,2.52,0,.61.09,1.2.15,1.79,0,.35.09.69.13,1,.09.58.18,1.18.3,1.75s.16.82.25,1.2a17.57,17.57,0,0,0,1.53,4.39,31.29,31.29,0,0,0,2,3.81c.17.26.36.52.55.76a2.22,2.22,0,0,0,.19.27,20.49,20.49,0,0,0,4.09,4.1c.14.11.29.22.43.31a12.3,12.3,0,0,0,4,1.95v.12l-.45,7.41c-12.09,3.64-16.19-5.94-16.19-5.94-.76,2.82.16,4.34.16,4.34-16.27-5.62-2.13-24.62-2.13-24.62,2.59-5,3-20.21,3-20.21-1.06-14.44,21.44-17.93,21.44-17.93,1.61-.4,3.14-.7,4.55-.91h0c15.14-2.34,19.46,5,19.46,5,13.2.08,16.09,10,16.08,18.62a51.09,51.09,0,0,1-1.8,12.83C507.06,306.2,498.55,318.5,498.55,318.5Z",
    fill: "#243E59"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M440.49,316.68s-7.59-4.1-3-15.2l5.92-10.94s.15,5.78,2.28,9.12c0,0-4.25,3.8-5.32,12.69A6.83,6.83,0,0,0,440.49,316.68Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M456.53,318.28l.45-7.53s-7.06-1.51-11.32-11.09c0,0-1.37,16.41,7.9,19.3Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M480.77,312.73a17.66,17.66,0,0,0,11.7-12.46,19.6,19.6,0,0,1-6.39,16.26l-5.62.76Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M483.66,287.36s4.66,18.2-8.47,25.71l-.19.11s-2.08,0-5-2.36c-.14-.1-.29-.23-.45-.37,14.28-5.92,12-24.32,12-24.32-6.69.77-8.36-7.74-8.36-7.74a12.84,12.84,0,0,0-.46,6.07C462.53,283.4,461,272.3,461,272.3a5.57,5.57,0,0,0-1.52,4,20.64,20.64,0,0,0-9-9.27s4.7-1.67,8.35,3.5a11.92,11.92,0,0,1,2.29-4.72s1.51,10.79,7.74,12.46c0,0,.31-5.62,2.13-8.2,0,0,1.67,14.14,21.42,11.39C492.46,281.42,491.1,285.23,483.66,287.36Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M470.89,258.93s7.29,5.78,6.08,10.49c0,0,7-2.28,13.37,1.06,0,0-1.52-4.4-11.09-4C478.62,266.56,479.09,260.45,470.89,258.93Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M502.93,276.65c-6.08-17.56-19.13-14.38-19.13-14.38A21,21,0,0,0,467.39,253h0c15.14-2.34,19.46,5,19.46,5C500.05,258.1,502.94,268,502.93,276.65Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M448.25,318.66s-7.15,3.8-2.74,9.72c0,0,12,16.87,34.5,8.51,0,0,13.61-6.65,8.35-14.43,0,0-5.31-.76-7.44-3.5v.76s4.56,12.92-15.43,11.63c0,0-8.28.07-12.38-7.3,0,0-2.33-3.42.27-5,0,0,0-.07,0-.07A12,12,0,0,1,448.25,318.66Z",
    fill: "#EC1C24"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M448.25,318.66s-7.15,3.8-2.74,9.72c0,0,12,16.87,34.5,8.51,0,0,13.61-6.65,8.35-14.43,0,0-5.31-.76-7.44-3.5v.76s4.56,12.92-15.43,11.63c0,0-8.28.07-12.38-7.3,0,0-2.33-3.42.27-5,0,0,0-.07,0-.07A12,12,0,0,1,448.25,318.66Z",
    fill: "#fff",
    opacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M450.37,362.27a59.72,59.72,0,0,1,8.39-.41,21.42,21.42,0,0,1,10.38,2.85c2.83,1.68,9.67,3.77,19.07-6.31h-26.9S451.74,357.71,450.37,362.27Z",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M502.12,360.68s8.89,8.89,7.06,21.65c0,0-5.24,29.86,4.56,36.25,0,0,29-2.51,50.15-18.24l-3.19-11.63s-1.37,10.72-14.82,15.28c0,0-28.49,15.73-31.23,1.36,0,0-3.06-4.78-2.34-14.36a22.75,22.75,0,0,1,.82-4.4C514.52,381.63,517.17,366.88,502.12,360.68Z",
    opacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M585.94,383a.16.16,0,0,0,.06.29c1.63.07,6.76.61.92,4.32a42,42,0,0,0-4.86,2.36c-.93.53-1.93,1.15-2.89,1.83a6.25,6.25,0,0,0-1.86,2.1c-1.16,2.12-4.67,6.64-13.41,6.47l-5.48-22.11s4.43-4.43,8-6.05a5.74,5.74,0,0,0,3-2.88,47.48,47.48,0,0,1,4.19-7.65c1.73-2.5,3.79-4.66,6-5.31,0,0,3,.22-3.11,14l-.18.41a.31.31,0,0,0,.48.36c.84-.71,2.09-1.74,3.51-2.8,3.55-2.64,8.11-5.41,9.56-3.56,0,0,2.14,2.35-5,10-.09.11,0,.28.16.2a13.74,13.74,0,0,1,5.72-2.05,2.66,2.66,0,0,1,2.54,1.23S595.74,376.13,585.94,383Z",
    fill: "#f9b499"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M568.75,371.59s2.38-1.65,4.08-1.2a1.21,1.21,0,0,1,.72,1.75,10,10,0,0,1-2.67,2.89.77.77,0,0,0-.3.69c.2,2.14.86,12-4,15.66,0,0,6.48,0,5.92-15a.76.76,0,0,1,.28-.63c.86-.72,3.28-3,2.75-5.4a2.13,2.13,0,0,0-2-1.61C572.36,368.7,570.62,369.17,568.75,371.59Z",
    fill: "#f7a48b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M576.51,370.37l-.08.1c1.46-4,2.76-8.77,1.66-10.62-.87-1.42-3.4.76-4.48,1.8,1.73-2.5,3.79-4.66,6-5.31C579.62,356.34,582.57,356.56,576.51,370.37Z",
    fill: "#f7a48b"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M584.88,374.75c4.68-7.07,3.35-8.25,3.35-8.25-.91-1.24-6.72,1.3-7.91,1.84,3.55-2.64,8.11-5.41,9.56-3.56C589.88,364.78,592,367.13,584.88,374.75Z",
    fill: "#f7a48b"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M585.94,383l4.51-5.59a3.56,3.56,0,0,0,.31-4.48,2.66,2.66,0,0,1,2.54,1.23S595.74,376.13,585.94,383Z",
    fill: "#f7a48b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M582.06,389.94a32.62,32.62,0,0,0-2.85,1.8,6.2,6.2,0,0,0-1.88,2.1c-1.11,2-4.43,6.39-12.63,6.5a.11.11,0,0,1,0-.22c1.62-.5,5.37-1.85,7-4a13.38,13.38,0,0,1,1.95-2C575.6,392.54,579.1,390,582.06,389.94Z",
    fill: "#f7a48b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M492.83,401.29s20.56,1.39,22.2,19l-24.29-.18,1.1-5.3-.18-11.32Z",
    fill: "#f9b499"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M511.38,420.12s-3.11-8.59-18.26-14.06h-1.46s.18,8.76-.92,14.06Z",
    fill: "#f7a48b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 417.04,
    y: 471.03,
    width: 110.81,
    height: 68.64,
    fill: "#EC1C24"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M393.25,332.78l-35,6-.28-2.44-17.89,6.54-16.27,5.93c-19-1.08-59.63-25.49-59.63-25.49,1.44-9.25,6.67-23.15,12-35.75C283,271.73,290,258,290,258,302.71,233.56,340,236.91,340,236.91l36.13,14c9.76,5.71,9.49,23.59,9.49,23.59Z",
    fill: "#EC1C24"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M393.25,332.78l-35,6-.28-2.44-17.89,6.54-16.27,5.93c-19-1.08-59.63-25.49-59.63-25.49,1.44-9.25,6.67-23.15,12-35.75C283,271.73,290,258,290,258,302.71,233.56,340,236.91,340,236.91l36.13,14c9.76,5.71,9.49,23.59,9.49,23.59Z",
    fill: "#fff",
    opacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M340.12,342.85l-16.27,5.93c-19-1.08-59.63-25.49-59.63-25.49,1.44-9.25,6.67-23.15,12-35.75l.06.07s-8.39,35,29.17,42.58Z",
    fill: "#fff",
    opacity: 0.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.52,366l-.29-1c.24-.07,24.13-6.87,31.25-28.23l1,.34C282.19,359,257.76,365.91,257.52,366Z",
    fill: "#fff"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M434.19,363s.88,24.38-1.89,32.6a2.3,2.3,0,0,1-.45.77c-1.28,1.5-6.17,7.82-.17,10.62,0,0,5,3,17.55-1.82,0,0,42-6.7,41.58,14.5,0,0,7.89-6.07,2-21.11,0,0-.23-6.16-17.09-4.34l-35.71.64a2.43,2.43,0,0,1-2.48-2.51C437.69,386.21,437.8,370.72,434.19,363Z",
    fill: "#EC1C24"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M434.19,363s.88,24.38-1.89,32.6a2.3,2.3,0,0,1-.45.77c-1.28,1.5-6.17,7.82-.17,10.62,0,0,5,3,17.55-1.82,0,0,42-6.7,41.58,14.5,0,0,7.89-6.07,2-21.11,0,0-.23-6.16-17.09-4.34l-35.71.64a2.43,2.43,0,0,1-2.48-2.51C437.69,386.21,437.8,370.72,434.19,363Z",
    opacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M411.47,434.15c-59.25,0-107.29,47.7-107.29,106.53s48,106.53,107.29,106.53,107.29-47.69,107.29-106.53S470.72,434.15,411.47,434.15Zm.91,197.56a91.79,91.79,0,1,1,91.79-91.79A91.8,91.8,0,0,1,412.38,631.71Z",
    fill: "#a7a9ac"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M412.39,448.13c-51.2,0-92.71,41.27-92.71,92.17s41.51,92.17,92.71,92.17,92.7-41.27,92.7-92.17S463.59,448.13,412.39,448.13Zm-1,178.23a86.29,86.29,0,1,1,86.34-86.29A86.32,86.32,0,0,1,411.39,626.36Z",
    fill: "#bcbec0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.46,
    cy: 540.03,
    rx: 86.41,
    ry: 86.21,
    fill: "#fff",
    opacity: 0.33
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.19,
    cy: 540.15,
    rx: 11.97,
    ry: 11.93,
    fill: "#a7a9ac"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 429.83,
    y1: 526.25,
    x2: 459.92,
    y2: 504.29,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 426.99,
    y1: 521.37,
    x2: 435.52,
    y2: 468.51,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 404.62,
    y1: 520.15,
    x2: 382.26,
    y2: 463.63,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 347.29,
    y1: 515.68,
    x2: 396.89,
    y2: 536.82,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 426.58,
    y1: 544.14,
    x2: 486.76,
    y2: 558.37,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 357.45,
    y1: 534.38,
    x2: 396.89,
    y2: 540.89,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 343.22,
    y1: 572.2,
    x2: 401.37,
    y2: 551.87,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 422.11,
    y1: 551.46,
    x2: 458.7,
    y2: 600.66,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 411.94,
    y1: 559.19,
    x2: 413.57,
    y2: 613.67,
    fill: "none",
    stroke: "#bcbec0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 523.92,
    y: 430.82,
    width: 9.32,
    height: 181.91,
    fill: "#d1d3d4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M542.6,426.07v7.32H400.74v-7.32a6.13,6.13,0,0,1,6.12-6.13H536.47A6.14,6.14,0,0,1,542.6,426.07Z",
    fill: "#d1d3d4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M542.6,426.07v7.32H400.74v-4.34h130a5.06,5.06,0,0,0,3.34-8.85l-.31-.26h2.71A6.14,6.14,0,0,1,542.6,426.07Z",
    fill: "#bcbec0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M568.54,519.81V614.2l-5.88-4-3.43-2.35V523.49a4.41,4.41,0,0,0-4.42-4.41H529.32v-10.3h28.19A11,11,0,0,1,568.54,519.81Z",
    fill: "#d1d3d4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M562.66,520v90.2l-3.43-2.35V523.49a4.42,4.42,0,0,0-4.42-4.41H529.32v-4.42h28A5.32,5.32,0,0,1,562.66,520Z",
    fill: "#bcbec0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.48,
    cy: 622.04,
    r: 26.97,
    fill: "#939598"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.54,
    cy: 622.04,
    rx: 19.12,
    ry: 20.1,
    fill: "#231f20",
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.8,
    cy: 621.8,
    r: 12.01,
    fill: "#231f20",
    opacity: 0.3
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M368.51,249.54c-1.71,22-15.88,20-15.88,20-8.52-1.7-12.25-11.74-13.88-19.85A66.56,66.56,0,0,1,337.48,239L351.9,227.8Z",
    fill: "#f9b499"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M368.51,249.54c-1.71,22-15.88,20-15.88,20-8.52-1.7-12.25-11.74-13.88-19.85,2,2.88,13.73,19.17,22.43,12,0,0,5.13-4.88-.24-7.82,0,0-8.31-6.35-4.16-15.63Z",
    fill: "#f7a48b"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.3,
    cy: 223.66,
    rx: 22.72,
    ry: 28.92,
    fill: "#f9b499"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M406.83,216.61c-.31,8.68-2.61,12.61-5,14.33a6.7,6.7,0,0,1-5.81.94,28.21,28.21,0,0,0,.91-6.72c-6.73-5.36-12-19-12-19a35.67,35.67,0,0,1-15.91,11,34.83,34.83,0,0,1-9.39,2L349.39,218l.69,12.54-10,6.38h-6.62c-3.64-9.8,4.11-16.41,4.11-16.41,6.61-5,4.33-13.46,4.33-13.46-3.42-19.37,13-16.4,13-16.4l42.56,2.72C405.93,198.21,406.83,216.61,406.83,216.61Z",
    fill: "#243E59"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M347.57,214.1s-.91-11.17,5.92-16.86A40.92,40.92,0,0,0,356,213.65Z",
    fill: "#231f20",
    opacity: 0.3
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M401.82,230.74v.2a6.7,6.7,0,0,1-5.81.94,28.21,28.21,0,0,0,.91-6.72c-6.73-5.36-12-19-12-19a35.67,35.67,0,0,1-15.91,11l-.51-.28c1.83-19.6-7.84-20.07-5-21.88,5.71-3.65,23.48-.23,23.48-.23C410.71,213.19,401.82,230.74,401.82,230.74Z",
    fill: "#231f20",
    opacity: 0.3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.04,
    cy: 220.91,
    rx: 7.8,
    ry: 10.1,
    fill: "#f9b499"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M398,193.57c-9.57,8.21-41.15,2.89-41.15,2.89l-4.2-12.14a1.28,1.28,0,0,1,.9-1.66,24.93,24.93,0,0,0,4-1.53,54.52,54.52,0,0,0,6.87-4c12.91-12,21.36-1.2,21.36-1.2,3.36,4.46,7.12,5.08,9.16,5a1.7,1.7,0,0,1,1.72,1.5l1.12,9.2Z",
    fill: "#EC1C24"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M398,193.57c-9.57,8.21-41.15,2.89-41.15,2.89l-4.2-12.14a1.28,1.28,0,0,1,.9-1.66,24.93,24.93,0,0,0,4-1.53c1.09,4.61,5.44,15.83,22,13.83l18.23-3.28Z",
    opacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M413,316.07c-4.23,5.75-32.7,13.33-38.37,14.8-.63.17-1,.25-1,.25-16.64,7.57-35,13.32-46.42,16.59-6.94,2-11.36,3-11.36,3-19.23,2.65-21-33.47-21-33.47l6-1.69,16.51-4.7,10.58-3,2.05,7.9a1.89,1.89,0,0,0,1.95,1.42L366.5,315a2.65,2.65,0,0,0,2.38-2c1.93-7.44,13.3-10.66,17.8-11.65a13.43,13.43,0,0,0,3.59-1.36c3.84-2.1,6.08-2.58,7.32-2.56A1.33,1.33,0,0,1,398.9,299c-.9,5.21-7.49,8.24-7.49,8.24-5.47,2.74-5,3.95-5,3.95-.49.74-.44,1.29,0,1.68,1.59,1.52,8.53.76,8.53.76a79.47,79.47,0,0,1,14.27.18C414.3,314.56,413,316.07,413,316.07Z",
    fill: "#f9b499"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M327.44,347.53l-.24.18c-6.94,2-11.36,3-11.36,3-19.23,2.65-21-33.47-21-33.47l6-1.69c.38,7.13,2.09,28.9,8.56,31.94C309.35,347.53,315.73,350.27,327.44,347.53Z",
    fill: "#f7a48b"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M320.17,324.78c2.18-5.1-2-12.4-2.87-13.89l10.58-3,2.05,7.9a1.89,1.89,0,0,0,1.95,1.42l-11.13,8.07A.39.39,0,0,1,320.17,324.78Z",
    fill: "#f7a48b"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M413,316.07c-4.23,5.75-32.7,13.33-38.37,14.8.47-1.64,2.08-4.13,7.41-4.95,0,0,22.91-4.74,27.15-12.09C414.3,314.56,413,316.07,413,316.07Z",
    fill: "#f7a48b"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M398.9,299c-.9,5.21-7.49,8.24-7.49,8.24-5.47,2.74-5,3.95-5,3.95-.49.74-.44,1.29,0,1.68-6.46-2.64,2.89-7.82,6.41-9.57a9.81,9.81,0,0,0,3.26-2.56,6.26,6.26,0,0,0,1.55-3.29A1.33,1.33,0,0,1,398.9,299Z",
    fill: "#f7a48b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M291.09,318.21l-5.31-36.11a23.1,23.1,0,0,1,0-6.59,26.56,26.56,0,0,1,6.16-14s-1.32,20,2.06,31.41c0,0,4.11,19.37,13.65,17.17,0,0,16.73-2.79,17.17-8.07l-2.2-31.26,8,35.72a2.71,2.71,0,0,1-1.34,3c-3.62,2-13.56,6.41-36.31,10.08A1.57,1.57,0,0,1,291.09,318.21Z",
    fill: "#EC1C24"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M291.09,318.21l-5.31-36.11a23.1,23.1,0,0,1,0-6.59,26.56,26.56,0,0,1,6.16-14s-1.32,20,2.06,31.41c0,0,4.11,19.37,13.65,17.17,0,0,16.73-2.79,17.17-8.07l-2.2-31.26,8,35.72a2.71,2.71,0,0,1-1.34,3c-3.62,2-13.56,6.41-36.31,10.08A1.57,1.57,0,0,1,291.09,318.21Z",
    fill: "#fff",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/nurse.9dea7f28e360fd65a67ee41933e128eb.svg";
export { ForwardRef as ReactComponent };